export enum IntegrationCategories {
  DSP = 'dsp',
  AD_SERVER = 'ad_server',
  AGENCY = 'agency',
}

export const ProviderForEndpoints: {
  [integration: string]: string;
} = {
  campaign_manager: 'campaign_manager',
};

export enum PLATFORM_NAMES {
  ADFORM = 'adform_ad_server',
}
